import { Main as MainAction } from "@actions/index";
import { Main } from "@models/index";
import { useDispatch } from "@helpers/Store";

export default class Workshop {
  public static async get() {
    try {
      const response = await new Main.Workshop().get();

      useDispatch(MainAction.Workshop.setData(response.data));
      return response.data;
    } catch (Exception) {}
  }
}
